import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logo",
  "use": "icon-logo-usage",
  "viewBox": "0 0 132 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 132 40\" class=\"design-iconfont\" id=\"icon-logo\">\n  <defs>\n    <mask id=\"icon-logo_slseghx9v__ybfadik6fa\">\n      <rect width=\"132\" height=\"40\" rx=\"0\" fill=\"#FFF\" />\n    </mask>\n  </defs>\n  <g mask=\"url(#icon-logo_slseghx9v__ybfadik6fa)\">\n    <rect y=\"-4\" width=\"132\" height=\"48\" rx=\"0\" fill=\"#FFF\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol